/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ g: NonNullable<unknown> }} Gaz_LevelInputs */



/**
* | output |
* | --- |
* | "Gas tank ({g}%)" |
*
* @param {Gaz_LevelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const gaz_level = /** @type {((inputs: Gaz_LevelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gaz_LevelInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Gas tank (${i?.g}%)`)
	return /** @type {LocalizedString} */ (`Cuve gaz (${i?.g}%)`)
});